// src/Redux/selectors/sharingSelectors.js

// ─────────────────────────────────────────────
// ACCESS LIST par document
// ─────────────────────────────────────────────

/** Retourne la liste d'accès d'un document (médecins ayant accès) */
export const selectAccessListByDocument = (documentId) => (state) =>
  state.sharing?.accessByDocument?.[documentId] || [];

/** Retourne uniquement les accès ACTIFS et non expirés */
export const selectActiveAccessListByDocument = (documentId) => (state) => {
  const list = state.sharing?.accessByDocument?.[documentId] || [];
  return list.filter(
    (entry) =>
      entry.status === "ACTIVE" && !entry.isExpired
  );
};

/** Retourne le statut de chargement pour un document donné */
export const selectAccessStatusByDocument = (documentId) => (state) =>
  state.sharing?.accessStatusByDocument?.[documentId] || {
    loading: false,
    error: null,
  };

/** Vérifie si un médecin spécifique a accès à un document */
export const selectDoctorHasAccess = (documentId, doctorId) => (state) => {
  const list = state.sharing?.accessByDocument?.[documentId] || [];
  return list.some(
    (entry) =>
      String(entry.doctorId) === String(doctorId) &&
      entry.status === "ACTIVE" &&
      !entry.isExpired
  );
};

/** Compte les accès actifs d'un document */
export const selectActiveAccessCountByDocument = (documentId) => (state) => {
  const list = state.sharing?.accessByDocument?.[documentId] || [];
  return list.filter(
    (entry) => entry.status === "ACTIVE" && !entry.isExpired
  ).length;
};

// ─────────────────────────────────────────────
// SHARE STATE
// ─────────────────────────────────────────────

export const selectShareLoading = (state) =>
  state.sharing?.shareLoading || false;

export const selectShareError = (state) => state.sharing?.shareError || null;

export const selectLastShareResult = (state) =>
  state.sharing?.lastShareResult || null;

// ─────────────────────────────────────────────
// REVOKE STATE
// ─────────────────────────────────────────────

export const selectRevokeLoading = (state) =>
  state.sharing?.revokeLoading || false;

export const selectRevokeError = (state) => state.sharing?.revokeError || null;

// ─────────────────────────────────────────────
// EXTEND ACCESS STATE
// ─────────────────────────────────────────────

export const selectExtendLoading = (state) =>
  state.sharing?.extendLoading || false;

export const selectExtendError = (state) => state.sharing?.extendError || null;

// ─────────────────────────────────────────────
// DOCTOR SHARED DOCUMENTS
// ─────────────────────────────────────────────

export const selectDoctorSharedDocuments = (state) =>
  state.sharing?.doctorSharedDocuments || [];

export const selectDoctorSharedDocumentsTotal = (state) =>
  state.sharing?.doctorSharedDocumentsTotal || 0;

export const selectDoctorSharedDocumentsLoading = (state) =>
  state.sharing?.doctorSharedDocumentsLoading || false;

export const selectDoctorSharedDocumentsError = (state) =>
  state.sharing?.doctorSharedDocumentsError || null;

// ─────────────────────────────────────────────
// PATIENT DOCTORS WITH ACCESS
// ─────────────────────────────────────────────

export const selectPatientDoctorsWithAccess = (state) =>
  state.sharing?.patientDoctorsWithAccess || [];

export const selectPatientDoctorsWithAccessLoading = (state) =>
  state.sharing?.patientDoctorsWithAccessLoading || false;

export const selectPatientDoctorsWithAccessError = (state) =>
  state.sharing?.patientDoctorsWithAccessError || null;

// ─────────────────────────────────────────────
// SHARING STATISTICS
// ─────────────────────────────────────────────

export const selectSharingStatistics = (state) =>
  state.sharing?.sharingStatistics || null;

export const selectSharingStatisticsLoading = (state) =>
  state.sharing?.sharingStatisticsLoading || false;

export const selectSharingStatisticsError = (state) =>
  state.sharing?.sharingStatisticsError || null;